import script from "./SettingsDepartmentsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDepartmentsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDepartmentsSection.vue?vue&type=style&index=0&id=1d558b93&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d558b93"]])

export default __exports__